import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { RoadmapVM } from './RoadmapVM';
import { RTEComponent, RTDComponent } from '../RTE/RTE';
import { Accordion } from '../Accordion';
import './Roadmap.scss';
import Icon from '@mdi/react';
import {
    mdiPencil,
    mdiMinus,
    mdiPlus
} from '@mdi/js';


const RoadmapComponent = (props) => {
    const [RTEMode, setRTEMode] = useState(false)
    const [roadmapContent, setRoadmapContent] = useState('')
    const vm = useRef(new RoadmapVM()).current;

    const handleSaveClick = () => {
        setRTEMode(false);
        setRoadmapContent(vm.text);
        vm.updateRoadmap()
    }

    const handleEditClick = () => {
        setRTEMode(true);
        vm.text = roadmapContent
    }

    const handleCancelClick = () => {
        setRTEMode(false);
        vm.text = roadmapContent
    }


    useEffect(() => {
        vm.getRoadmap();
        setRoadmapContent(vm.roadmapDescription)
    }, [vm.roadmapDescription]);

    return (
        <Accordion className="p-0 accordion-wrapper" headers={['NETS Roadmap']} >
            <div className='sub-container'>

                {!RTEMode &&
                    <div className="action-menu-wrapper roadmap-wrapper">
                        <button className='usa-button usa-button--outline edit-card-button' aria-label='edit roadmap' disabled={RTEMode} onClick={() => { handleEditClick() }}><Icon path={mdiPencil} size={1} />
                            Edit
                        </button>
                    </div>}

                <div className="rte-container">
                    {!props.buttomContainer && roadmapContent && (!RTEMode) &&
                        <RTDComponent htmlString={roadmapContent} />
                    }
                    {!props.buttomContainer && RTEMode &&
                        <RTEComponent saveCallback={vm.updateCallback} initialValue={roadmapContent} contentString={vm.text} />
                    }
                </div>

                {(RTEMode && !props.buttomContainer) ?
                    <div className="save-button-container">
                        <button className="usa-button usa-button--outline btn3" aria-label="Cancel" onClick={handleCancelClick} >
                            Close
                        </button>
                        <button className="usa-button btn3" aria-label="Save" onClick={handleSaveClick}>
                            Save
                        </button>
                    </div>
                    : null}

            </div>
        </Accordion>
    );
};

export const Roadmap = observer(RoadmapComponent);